let filterInvo = function() {	
	return this.InvoicesListResult;
};
export default filterInvo;
